import {Component, ContentChildren, EventEmitter, Output, QueryList} from '@angular/core';
import {TabComponent} from './tab/tab.component';
import {IDocSelectedEvent} from '../uebersicht.component';

@Component({
    selector: 'frageboegen-tabbar',
    templateUrl: './tabbar.component.html',
    styleUrls: ['./tabbar.component.scss']
})
export class TabbarComponent {
    @ContentChildren(TabComponent) tabs: QueryList<TabComponent>;
    @Output() selected: EventEmitter<IDocSelectedEvent> = new EventEmitter<IDocSelectedEvent>();

    tabSelected(tab: TabComponent): void {
        this.tabs.toArray().forEach(t => t.active = false);
        tab.active = true;
        this.selected.emit({
            name: tab.name
        });
    }
}
